import AddressGrid from '@components/address/address-grid';
import {useEffect, useState} from "react";
import {CustomerAddress, Nullable} from "@framework/types";
import {useGetUserProfile} from "@framework/auth/use-get-user-profile";

const AddressPage: React.FC<{
  lang: string,
  onSelectedAddress?: (addAddress: Nullable<CustomerAddress>) => any
}> = ({lang, onSelectedAddress}) => {
  let {data: user, isLoading, isError} = useGetUserProfile();
  const [selected, setSelected] = useState<Nullable<CustomerAddress>>();

  const saveSelectedAddress = (addAddress: Nullable<CustomerAddress>) => {
    setSelected(addAddress)
    if (onSelectedAddress) {
      onSelectedAddress(addAddress)
    }
  }

  useEffect(() => {
    if (user?.addresses.length && !selected) {
      saveSelectedAddress(user.addresses[0])
    }
  }, [user])

  return !isLoading ? !isError ? (
      <AddressGrid addresses={user!!.addresses}
                   selectedAddress={selected}
                   onAddressSelected={saveSelectedAddress}
                   lang={lang}/>
  ) : <div>Error...</div> : <div>Loading...</div>;
};

export default AddressPage;
